import { useSelector } from 'react-redux';
import { useFeatureFlag } from './useFeatureFlag';
import { FeatureFlagKeys } from '../constants/ff.posthog';
import { RemoteConfigUtils, isVersionAtLeast } from '../utils/RemoteConfigUtils';

export const useCredentialingV2 = () => {
  const isCredentialingV2FF = useFeatureFlag(FeatureFlagKeys.credentialingV2);
  const clientVersion = useSelector((state) => state.users.currentUser?.client_version);
  const minAppVersion = RemoteConfigUtils.getCredentialingV2MinAppVersion();

  return isCredentialingV2FF && isVersionAtLeast(clientVersion, minAppVersion);
};
